export const MAX_ALLOWED_RECEIVERS = 200
export const MAX_ALLOWED_RECEIVERS_ERROR_MESSAGE = `You can't send message for more than ${MAX_ALLOWED_RECEIVERS} receivers`
